import React from 'react';
import { styled } from '@mui/system';

import { Container } from 'components/Containers';

const StyledContainer = styled(Container)({
  padding: '20px 16px'
});

export function ScreenContainer(props) {
  return <StyledContainer data-testid="screen-container" {...props} />;
}
